<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品出库列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
      </el-tabs>
      <el-row>
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1 && tabIndex != 5">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status + '&order_id=' + queryInfo.query 
          + '&agencyName=' + queryInfo.agencyName + '&tid='+ queryInfo.tid">
            <el-button size="mini" type="info">导出订单</el-button>
          </a>
        </el-col>
      </el-row>

      <el-table
        id="out-table"
        :data="orderlist"
        border
        stripe
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        @filter-change="handleFilterChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" fixed :key="Math.random()"> </el-table-column>

        <el-table-column label="商品信息" type="expand" width="70px" :key="Math.random()">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark">
              <el-table-column label="商品名称" align="center" prop="goodinfo.title" width="180px"> </el-table-column>
              <el-table-column label="商品编号" prop="goodinfo.number" width="70px"> </el-table-column>
              <el-table-column label="商品规格" prop="goodinfo.preNum" width="70px"> </el-table-column>

              <el-table-column label="商品单价" prop="goodinfo.price" align="center" width="70px"> </el-table-column>
              <el-table-column label="参与活动" prop="goodinfo.activityContent" align="center" width="120px"> </el-table-column>
              <el-table-column label="购买数量" prop="goodinfo.buyNum" width="70px"> </el-table-column>
              <el-table-column label="赠送件数" prop="goodinfo.sendNumber" width="70px"> </el-table-column>
              <el-table-column label="数量小计" prop="goodinfo.goodTotalNum" width="70px"> </el-table-column>

              <el-table-column label="预定下周订单截止时间" prop="goodinfo.g_endTime" align="center" width="150px" v-if="scope.row.good_type == 2"> </el-table-column>
              <el-table-column label="是否已确定商品" prop="goodinfo.statusTxt" align="center" width="120px" v-if="scope.row.good_type == 2"> </el-table-column>
              <el-table-column label="下周/下下周" prop="goodinfo.week" align="center" width="130px" v-if="scope.row.good_type == 2"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column type="index" :key="Math.random()"></el-table-column>
        <el-table-column label="订单编号" prop="order_id" width="100px" :key="Math.random()"></el-table-column>
        <el-table-column label="下单经销商" prop="agencyName" align="center" width="110px"  :key="Math.random()"></el-table-column>
        <!-- <el-table-column label="类型" prop="type" align="center" width="120px"> </el-table-column> -->
        <!-- <el-table-column :label="typeTxt" align="center" :filter-multiple="false" :column-key="'type'" :filters="filterStatus" prop="type" width="100px"></el-table-column> -->

        <el-table-column align="center" width="140px"  :key="Math.random()">
          <template slot="header" slot-scope="scope">
            <el-select v-model="typeValue" size="mini" @change="changeType" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == '常温订单'">常温订单</el-tag>
            <el-tag class="info" v-if="scope.row.type == '低温订单'">低温订单</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="商品总价" prop="order_amount_total" align="center" width="80px"  :key="Math.random()"></el-table-column>
        <el-table-column label="商品总数量" prop="totalNum" align="center" width="80px"  :key="Math.random()"></el-table-column>
        <el-table-column label="状态" prop="order_status" align="center" width="80px"  :key="Math.random()">
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.order_status == '0'">未付款</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.order_status == '1'">待确认</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.order_status == '2'">待发货</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.order_status == '3'">已发货</el-tag>
            <el-tag type="success" v-if="scope.row.order_status == '4'">已完成</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '0'">退款中，待确认</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '1'">退款成功</el-tag>
            <el-tag type="info" v-if="scope.row.order_status == '6'">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" prop="create_at" width="150px"  :key="Math.random()">
          <template slot-scope="scope">
            {{ scope.row.create_at | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column label="收货地址" prop="addressDetail" align="center" width="420px"  :key="Math.random()"></el-table-column>
        <el-table-column label="是否打印" v-if="tabIndex == 2" prop="printed" align="center" width="70px"  :key="Math.random()"> </el-table-column>
        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
             <el-button size="mini" type="primary" v-if="tabIndex < 3" @click="editOrder(scope.row.order_id,scope.row.good_type)">编辑</el-button>

            <el-button size="mini" type="info" v-if="scope.row.order_status == 2" @click="sendOrder(scope.row.order_id)">发货</el-button>
            <!-- <a class="aaaa" v-if="scope.row.isCanPrint == 1 && tabIndex == 2" target="_blank" href="https://hsadmin.sqmilk.com/print.html"> -->
            <a class="aaaa" target="_blank" href="https://hsadmin.sqmilk.com/print.html">
              <el-button size="mini" @click="exportOrder(scope.row.order_id)" type="info">打印出货单</el-button>
            </a>
            <el-button size="mini" @click="noCanPrint" v-if="scope.row.isCanPrint == 0 && tabIndex == 2" type="info">打印出货单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 修改地址的对话框 -->
    <el-dialog title="发货信息" :visible.sync="sendVisible" width="50%" @close="sendDialogClosed">
      <el-form :model="sendForm" :rules="sendFormRules" ref="sendFormRef" label-width="100px">
        <el-form-item label="司机姓名" prop="sendName">
          <el-input v-model="sendForm.sendName"></el-input>
        </el-form-item>
        <el-form-item label="司机电话" prop="sendPhone">
          <el-input v-model="sendForm.sendPhone" maxlength="11"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="sendVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendVisibleSure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="de" width="80%" >
      <Detail ref="Detail"  :valueId="order_id"/>
    </el-dialog>
    <el-dialog :visible.sync="des" width="80%" >
      <DwDetail ref="DwDetail"  :valueId="order_id"/>
    </el-dialog>
  </div>
</template>

<script>
import Detail from "../order/Detail"
import DwDetail from "../order/DwDetail"
export default {
  components: {
    Detail,
    DwDetail
  },
  data () {

    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error('请输入合法的手机号'))
    }
    return {
      de:false,
      des:false,
      order_id:'',
      tabIndex: 0,
      canLook: 1,
      orderData: {},
      exportUrl: 'https://hsapi.sqmilk.com/kucunexportExcel?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        query: '',
        time: null,
        status: -1,
        type: 0,
        tid: 0,
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待发货', id: 2 },
        { value: '已发货', id: 3 },
      ],

      typeOptions: [
        { value: '常温产品', id: 1 },
        { value: '低温产品', id: 2 },
      ],
      // typeValue: "商品类型",

      typeValue: '订单类型',
      options: [
        { label: '订单类型', value: 0 },
        { label: '常温订单', value: 1 },
        { label: '低温订单', value: 2 },
      ],
      total: 0,
      orderlist: [],
      sendVisible: false,
      sendForm: {
        sendName: null,
        sendPhone: null
      },
      sendOrderId: 0,
      sendFormRules: {
        sendName: [
          { required: true, message: '请输入司机名字', trigger: 'blur' }
        ],
        sendPhone: [
          { required: true, message: '请输入司机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      progressVisible: false,
      progressInfo: [],
      typeTxt: "商品类型",
      filterStatus: [
        { text: '常温产品', value: 1 },
        { text: '低温产品', value: 2 }],
    }
  },

  created () {
    this.getOrderList();
  },

  methods: {
     timechange (e) {
      this.filterSelect();
    },

    //搜索
    search () {
      this.filterSelect();
    },
     // 编辑
    editOrder(id,good_type) {
      this.order_id = id,
      // this.de = true
      console.log(id)
      if(good_type===1){
        this.de = true
      }else{
        this.des = true
      }
      // const url = good_type==1?'/orders/detail':'orders/dwdetail';
      // this.$router.push({ path: url, query: { id: id} })
    },

    changeType (value) {
      console.log(value);
      this.queryInfo.tid = value
      this.queryInfo.pagenum = 1
      this.getOrderList(); // 通过接口获取数据的方法
    },
    
    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.sqmilk.com/kucunexportExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.sqmilk.com/kucunexportExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    handleFilterChange (filters) {
      console.log(filters);
      if (filters.type.length > 0) {
        this.queryInfo.tid = filters.type[0]
        if (this.queryInfo.tid == 1) {
          this.typeTxt = "常温商品"
        } else if (this.queryInfo.tid == 2) {
          this.typeTxt = "低温商品"
        } else {
          this.typeTxt = "商品类型"
        }
      } else {
        this.queryInfo.tid = 0;
        this.typeTxt = "商品类型"
        console.log(this.queryInfo);
      }
      this.getOrderList();
    },

    handleClick (tab, event) {
      console.log(tab);
      this.tabIndex = tab.index;
      this.queryInfo.status = this.tabIndex
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    noCanPrint () {
      this.$message.error('请先发货，后打印')
    },

    sendOrder (id) {
      this.sendOrderId = id
      this.sendVisible = true
    },

    sendDialogClosed () {
      this.$refs.sendFormRef.resetFields()
    },

    trim (s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    async sendVisibleSure () {
      this.$refs.sendFormRef.validate(async valid => {
        if (!valid) return
        if (!this.trim(this.sendForm.sendName)) {
          return this.$message.error('司机不能为空')
        }
        const { data: res } = await this.$http.post('admin/order/sendOrdersById', {
          order_id: this.sendOrderId,
          sendName: this.sendForm.sendName,
          sendPhone: this.sendForm.sendPhone,
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.$message.success('订单发货成功！')
        this.sendVisible = false
        this.getOrderList()
      })
    },

    // 批量发货订单
    async sendOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/order/getReadySureOrderList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取订单列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    exportOrder (order_id) {
      console.log(order_id,'order123456');
      // 存储
      localStorage.setItem("kuncun_order_id", order_id);
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },
  }
}
</script>

<style lang="less" scoped>
.el-select {
  width: 135px;
}

.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}

.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
